<template>
  <Modal :show="true" centered size="fluid" title="Comprobante" @hide="$emit('hide', flags.reload)">
    <Comprobante2
      :initialModo="1"
      :initialCliente="{
        agencia: comprobante.idAgencia,
      }"
      :initialComprobante="{
        moneda: comprobante.idMoneda,
      }"
      :initialItems="comprobante.items"
      @facturar="onFacturar"
    ></Comprobante2>
  </Modal>
</template>

<script>
import Comprobante2 from "../../comprobantes/components/Comprobante2.vue";
import Modal from "../../shared/components/Modal.vue";

export default {
  components: { Modal, Comprobante2 },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    comprobante: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      flags: {
        reload: false,
      },
    };
  },
  async created() {},
  computed: {},
  methods: {
    onFacturar() {
      this.flags.reload = true;
    },
  },
};
</script>
